import { render, staticRenderFns } from "./PowerFewShotContent.vue?vue&type=template&id=a1222306&scoped=true"
import script from "./PowerFewShotContent.vue?vue&type=script&lang=js"
export * from "./PowerFewShotContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1222306",
  null
  
)

export default component.exports